module.exports = __webpack_public_path__ + "img/coreFun_bg.2a03a88d.png";